var COLOR_MODE_KEY = "cbook-color-mode";
export var COLOR_MODES = [
    "light",
    "dark",
    "auto"
];
export var updateColorModeAttribute = function(mode) {
    var _document_getElementById, _document_getElementById_contentWindow, _document_getElementById_contentWindow_document;
    document.documentElement.setAttribute("color-mode", mode);
    var iframeHTML = (_document_getElementById = document.getElementById("ext-iframe")) === null || _document_getElementById === void 0 ? void 0 : (_document_getElementById_contentWindow = _document_getElementById.contentWindow) === null || _document_getElementById_contentWindow === void 0 ? void 0 : (_document_getElementById_contentWindow_document = _document_getElementById_contentWindow.document) === null || _document_getElementById_contentWindow_document === void 0 ? void 0 : _document_getElementById_contentWindow_document.documentElement;
    if (iframeHTML) {
        iframeHTML.setAttribute("color-mode", mode);
    }
};
export var getColorMode = function() {
    return localStorage.getItem(COLOR_MODE_KEY) || "auto";
};
var getSystemColorMode = function() {
    if (!window.matchMedia) return "light";
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};
export var applyColorMode = function() {
    var colorMode = getColorMode();
    updateColorModeAttribute(colorMode === "auto" ? getSystemColorMode() : colorMode);
};
export var updateAndApplyColorMode = function(newColorMode) {
    localStorage.setItem(COLOR_MODE_KEY, newColorMode);
    applyColorMode();
};
